import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import SinglePlanEditApi from '~/api/SinglePlanEditApi';
import { selectMainClientId } from '~/reducers/mainClientSlice';
import { addProcessIndicator } from '~/reducers/processIndicatorSlice';
import { selectDateOnly } from '~/reducers/selectedDateSlice';
import constants from '~/utils/constants';
import { pageUtils } from '~/utils/page-utils';
import throttleRequestsHandler from '~/utils/socket/throttle-requests';

export const useRepairPlan = () => {
    const { t } = useTranslation('translation');
    const dispatch = useDispatch();
    const routeDate = useSelector(selectDateOnly);
    const mainClientId = useSelector(selectMainClientId);

    const repairPlan = useCallback(async () => {
        const processIndicatorState = {
            message: t('RepairPlan.inProgress'),
            type: constants.processIndicator.REPAIR_PLAN,
            inProgress: true,
            error: false,
            position: 'center'
        };

        if (!routeDate) {
            console.warn('Route date is missing');
            return;
        }

        try {
            dispatch(addProcessIndicator(processIndicatorState));
            await SinglePlanEditApi.repairPlan({
                date: routeDate
            });
            dispatch(
                addProcessIndicator({
                    ...processIndicatorState,
                    inProgress: false,
                    message: t('RepairPlan.done')
                })
            );
            pageUtils.resetPlanPageReducers();
            throttleRequestsHandler.requestWebPlan({
                clientId: mainClientId,
                routeDate
            });
        } catch (e) {
            console.warn(e);
            dispatch(
                addProcessIndicator({
                    ...processIndicatorState,
                    inProgress: false,
                    error: true
                })
            );
        }
    }, [dispatch, mainClientId, routeDate, t]);

    return { repairPlan };
};
